module.exports = __webpack_public_path__ + "static/media/5_The Cracked pot_UAE.79e9afe9.txt";